import React from "react";
import failedLogo from "../../assets/images/payment-failed.svg";

type Props = {
  message?: string;
};

export const PaymentFailed: React.FC<Props> = ({ message }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "rgba(128, 128, 128, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
            color: "black",
            fontSize: "25px",
            flexDirection: "column",
            width: "80%",
            maxWidth: "500px",
            gap: "40px",
            backgroundColor: "#fff",
            padding: "1rem",
            borderRadius: "5px",
          }}
        >
          <img src={failedLogo} alt="" />
          <p style={{ fontSize: "0.95rem", fontWeight: "700" }}>
            {message ?? "Unable to load payment link details"}
          </p>
        </div>
      </div>
    </>
  );
};
